"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3344],{

/***/ 94996:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31501);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61079);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67496);
/* harmony import */ var _ui_providers_VenoSDKProvider__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29142);
/* harmony import */ var _ui_queries_sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94693);
/* harmony import */ var _veno_app_wallet__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95142);






var useAccount = _veno_app_wallet__WEBPACK_IMPORTED_MODULE_2__/* .currentWallet.useAccount */ .AX.useAccount;
var useTLcroBalance = function(options, address) {
    var sdk = (0,_ui_providers_VenoSDKProvider__WEBPACK_IMPORTED_MODULE_0__/* .useVenoSDK */ .ho)();
    var userAccount = useAccount();
    var account = address !== null && address !== void 0 ? address : userAccount;
    var query = (0,_ui_queries_sdk__WEBPACK_IMPORTED_MODULE_1__/* .getTLcroBalance */ .uQ)(sdk, account !== null && account !== void 0 ? account : "");
    var ref = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .a)(query.queryKey, query.queryFn, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, options), {
        enabled: !!account && ((options === null || options === void 0 ? void 0 : options.enabled) === undefined || (options === null || options === void 0 ? void 0 : options.enabled))
    })), tlcroBalance = ref.data, isLoading = ref.isLoading;
    return {
        loading: isLoading,
        tlcroBalance: tlcroBalance
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useTLcroBalance);


/***/ }),

/***/ 8623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _ui_config_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99421);
/* harmony import */ var _useFerroLpBalance__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62996);
/* harmony import */ var _useTLcroBalance__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94996);
/* harmony import */ var _useVvsCroLpBalance__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28038);
/* harmony import */ var _useVvsLpBalance__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91389);





var useTotalGardenDeposit = function(gardenType) {
    var addresses = (0,_ui_config_base__WEBPACK_IMPORTED_MODULE_0__/* .getContractAddresses */ .o)();
    var ref = (0,_useTLcroBalance__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        enabled: gardenType === "TECTONIC"
    }, addresses.venoStorm), tlcroTotalBalance = ref.tlcroBalance;
    var ref1 = (0,_useFerroLpBalance__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
        enabled: gardenType === "FERRO"
    }, addresses.venoStorm), ferroTotalBalance = ref1.ferroLpBalance;
    var ref2 = (0,_useVvsLpBalance__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        enabled: gardenType === "VVS"
    }, addresses.venoStorm), vvsTotalBalance = ref2.vvsLpBalance;
    var ref3 = (0,_useVvsCroLpBalance__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        enabled: gardenType === "VVS_CRO"
    }, addresses.venoStorm), vvsCroTotalBalance = ref3.vvsCroLpBalance;
    var totalBalance = ferroTotalBalance;
    switch(gardenType){
        case "VVS":
            totalBalance = vvsTotalBalance;
            break;
        case "VVS_CRO":
            totalBalance = vvsCroTotalBalance;
            break;
        case "TECTONIC":
            totalBalance = tlcroTotalBalance;
            break;
    }
    return {
        totalBalance: totalBalance
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useTotalGardenDeposit);


/***/ }),

/***/ 28038:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31501);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61079);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67496);
/* harmony import */ var _ui_providers_VenoSDKProvider__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29142);
/* harmony import */ var _ui_queries_sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94693);
/* harmony import */ var _veno_app_wallet__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95142);






var useAccount = _veno_app_wallet__WEBPACK_IMPORTED_MODULE_2__/* .currentWallet.useAccount */ .AX.useAccount;
var useVvsLpBalance = function(options, address) {
    var sdk = (0,_ui_providers_VenoSDKProvider__WEBPACK_IMPORTED_MODULE_0__/* .useVenoSDK */ .ho)();
    var userAccount = useAccount();
    var account = address !== null && address !== void 0 ? address : userAccount;
    var query = (0,_ui_queries_sdk__WEBPACK_IMPORTED_MODULE_1__/* .getVvsCroLpBalance */ .Bm)(sdk, account !== null && account !== void 0 ? account : "");
    var ref = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .a)(query.queryKey, query.queryFn, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, options), {
        enabled: !!account && ((options === null || options === void 0 ? void 0 : options.enabled) === undefined || (options === null || options === void 0 ? void 0 : options.enabled))
    })), vvsCroLpBalance = ref.data, isLoading = ref.isLoading;
    return {
        loading: isLoading,
        vvsCroLpBalance: vvsCroLpBalance
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useVvsLpBalance);


/***/ }),

/***/ 91389:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31501);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61079);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67496);
/* harmony import */ var _ui_providers_VenoSDKProvider__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29142);
/* harmony import */ var _ui_queries_sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94693);
/* harmony import */ var _veno_app_wallet__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95142);






var useAccount = _veno_app_wallet__WEBPACK_IMPORTED_MODULE_2__/* .currentWallet.useAccount */ .AX.useAccount;
var useVvsLpBalance = function(options, address) {
    var sdk = (0,_ui_providers_VenoSDKProvider__WEBPACK_IMPORTED_MODULE_0__/* .useVenoSDK */ .ho)();
    var userAccount = useAccount();
    var account = address !== null && address !== void 0 ? address : userAccount;
    var query = (0,_ui_queries_sdk__WEBPACK_IMPORTED_MODULE_1__/* .getVvsLpBalance */ .pL)(sdk, account !== null && account !== void 0 ? account : "");
    var ref = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .a)(query.queryKey, query.queryFn, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, options), {
        enabled: !!account && ((options === null || options === void 0 ? void 0 : options.enabled) === undefined || (options === null || options === void 0 ? void 0 : options.enabled))
    })), vvsLpBalance = ref.data, isLoading = ref.isLoading;
    return {
        loading: isLoading,
        vvsLpBalance: vvsLpBalance
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useVvsLpBalance);


/***/ }),

/***/ 26835:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ GardenLogo; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(31501);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(61079);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(89874);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35250);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(66697);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(18912);
/* harmony import */ var _ui_components_LPTokenIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40266);
/* harmony import */ var _ui_components_MobileOrDesktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60303);
/* harmony import */ var _ui_hooks_useFarmAprs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31910);
/* harmony import */ var _ui_hooks_useTotalGardenDeposit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8623);
/* harmony import */ var _ui_utils_format__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25966);
/* harmony import */ var _ui_utils_garden__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(98097);
/* harmony import */ var _veno_app_chakra__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52746);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70079);
/* harmony import */ var _GardenBooster__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(73068);














var GardenLogo = function(_param) {
    var coinMode = _param.coinMode, gardenType = _param.gardenType, _showGardenName = _param.showGardenName, showGardenName = _showGardenName === void 0 ? true : _showGardenName, _showTVL = _param.showTVL, showTVL = _showTVL === void 0 ? true : _showTVL, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_param, [
        "coinMode",
        "gardenType",
        "showGardenName",
        "showTVL"
    ]);
    var isBoosted = (0,_ui_hooks_useFarmAprs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)().isBoosted;
    var totalBalance = (0,_ui_hooks_useTotalGardenDeposit__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(gardenType).totalBalance;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Flex */ .kC, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({
        flexDirection: "column",
        alignItems: "center",
        pt: {
            desktop: isBoosted ? "6px" : 0
        }
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Flex */ .kC, {
                justify: "center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Flex */ .kC, {
                    w: "60px",
                    h: "60px",
                    justify: "center",
                    align: "center",
                    bg: "white",
                    rounded: "full",
                    boxShadow: "var(".concat(_veno_app_chakra__WEBPACK_IMPORTED_MODULE_7__/* .ColorThemeVars.parentSmallShadow */ .lx.parentSmallShadow, ")"),
                    position: "relative",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_14__/* .Image */ .Ee, {
                            alt: "Brand Image",
                            w: "full",
                            h: "full",
                            src: (0,_ui_utils_garden__WEBPACK_IMPORTED_MODULE_6__/* .getGardeAvatarUrl */ .Mo)(gardenType)
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ui_components_MobileOrDesktop__WEBPACK_IMPORTED_MODULE_2__/* .InDesktop */ .Fe, {
                            children: isBoosted && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_GardenBooster__WEBPACK_IMPORTED_MODULE_9__/* .GardenBooster */ .d, {
                                position: "absolute",
                                top: "0"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_ui_components_MobileOrDesktop__WEBPACK_IMPORTED_MODULE_2__/* .InDesktop */ .Fe, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Text */ .xv, {
                        as: "h1",
                        hidden: !showGardenName,
                        textStyle: "h3",
                        mt: "6px",
                        children: (0,_ui_utils_garden__WEBPACK_IMPORTED_MODULE_6__/* .getGardenName */ .gr)(coinMode, gardenType, false)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Box */ .xu, {
                        hidden: !showTVL,
                        mx: "auto",
                        textAlign: "center",
                        textStyle: "body",
                        color: "text-light",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_ui_components_LPTokenIcon__WEBPACK_IMPORTED_MODULE_1__/* .LPTokenIcon */ .u, {
                            coinMode: coinMode,
                            gardenType: gardenType,
                            children: [
                                "TVL",
                                " ",
                                (0,_ui_utils_format__WEBPACK_IMPORTED_MODULE_5__/* .formatTokenAmount */ .LH)(totalBalance, 3, _ui_utils_garden__WEBPACK_IMPORTED_MODULE_6__/* .gardenTokenDict */ .Hx[coinMode][gardenType].decimals)
                            ]
                        })
                    })
                ]
            })
        ]
    }));
};


/***/ }),

/***/ 3344:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ UseLcroDirectly_SupplyLcroModal; }
});

// EXTERNAL MODULE: ../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(35250);
// EXTERNAL MODULE: ../node_modules/.pnpm/@chakra-ui+modal@2.2.1_@chakra-ui+system@2.2.12_@types+react@18.0.21_framer-motion@7.4.0_react-dom@18.2.0_react@18.2.0/node_modules/@chakra-ui/modal/dist/index.esm.js + 58 modules
var index_esm = __webpack_require__(96950);
// EXTERNAL MODULE: ../node_modules/.pnpm/@chakra-ui+button@2.0.11_@chakra-ui+system@2.2.12_react@18.2.0/node_modules/@chakra-ui/button/dist/index.esm.js
var dist_index_esm = __webpack_require__(31327);
// EXTERNAL MODULE: ../node_modules/.pnpm/@chakra-ui+icon@3.0.11_@chakra-ui+system@2.2.12_react@18.2.0/node_modules/@chakra-ui/icon/dist/index.esm.js
var icon_dist_index_esm = __webpack_require__(93193);
// EXTERNAL MODULE: ../node_modules/.pnpm/@chakra-ui+layout@2.1.8_@chakra-ui+system@2.2.12_react@18.2.0/node_modules/@chakra-ui/layout/dist/index.esm.js
var layout_dist_index_esm = __webpack_require__(66697);
// EXTERNAL MODULE: ../node_modules/.pnpm/@chakra-ui+image@2.0.11_@chakra-ui+system@2.2.12_react@18.2.0/node_modules/@chakra-ui/image/dist/index.esm.js
var image_dist_index_esm = __webpack_require__(18912);
// EXTERNAL MODULE: ./src/components/Balance/index.ts
var Balance = __webpack_require__(64345);
// EXTERNAL MODULE: ./src/components/Features.tsx
var Features = __webpack_require__(18232);
// EXTERNAL MODULE: ./src/components/Info/index.ts
var Info = __webpack_require__(13614);
// EXTERNAL MODULE: ./src/components/InfoTooltip.tsx + 3 modules
var InfoTooltip = __webpack_require__(28521);
// EXTERNAL MODULE: ./src/components/InputCard/index.ts
var InputCard = __webpack_require__(22806);
// EXTERNAL MODULE: ./src/components/MobileOrDesktop.tsx
var MobileOrDesktop = __webpack_require__(60303);
// EXTERNAL MODULE: ./src/components/TokenIcon.tsx
var TokenIcon = __webpack_require__(47982);
// EXTERNAL MODULE: ./src/hooks/useCoinMode.tsx
var useCoinMode = __webpack_require__(93397);
// EXTERNAL MODULE: ./src/hooks/useIsFeatureEnabled.ts
var useIsFeatureEnabled = __webpack_require__(79623);
// EXTERNAL MODULE: ./src/i18n/index.ts
var i18n = __webpack_require__(68866);
// EXTERNAL MODULE: ./src/utils/constants.ts
var constants = __webpack_require__(21519);
// EXTERNAL MODULE: ./src/utils/format.ts
var format = __webpack_require__(25966);
// EXTERNAL MODULE: ./src/utils/garden.ts
var garden = __webpack_require__(98097);
// EXTERNAL MODULE: ../packages/chakra/dist/esm/index.js + 27 modules
var esm = __webpack_require__(52746);
// EXTERNAL MODULE: ../packages/icons/dist/esm/index.js + 53 modules
var dist_esm = __webpack_require__(99784);
// EXTERNAL MODULE: ../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(70079);
// EXTERNAL MODULE: ./src/components/NoteBox.tsx
var NoteBox = __webpack_require__(24361);
// EXTERNAL MODULE: ../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(31501);
// EXTERNAL MODULE: ../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(61079);
// EXTERNAL MODULE: ../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(89874);
;// CONCATENATED MODULE: ./src/views/UseLcroDirectly/AssetExplainer.tsx








function AssetExplainer(_param) {
    var coinMode = _param.coinMode, type = _param.type, explainText = _param.explainText, flexProps = (0,_object_without_properties/* default */.Z)(_param, [
        "coinMode",
        "type",
        "explainText"
    ]);
    var t = (0,i18n/* useTranslations */.T_)();
    var gardenToken = garden/* gardenTokenDict */.Hx[coinMode][type];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Flex */.kC, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        flexDir: "column",
        px: {
            base: 0,
            desktop: 8
        },
        py: {
            base: 0,
            desktop: 4
        },
        minW: {
            base: "full"
        }
    }, flexProps), {
        children: [
            explainText === "TOKEN" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Box */.xu, {
                children: [
                    t("{coin} represents your share of the {poolName} pool on {protocolName}", {
                        coin: gardenToken.name,
                        poolName: gardenToken.poolName,
                        protocolName: gardenToken.protocolName
                    }),
                    " ",
                    type === "TECTONIC" && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: t("The value of {coin} will increase as interest is earned over time", {
                            coin: gardenToken.name
                        })
                    })
                ]
            }),
            explainText === "GARDEN" && /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Box */.xu, {
                children: t("Deposit your received {coin} into the {gardenName} to receive VNO rewards", {
                    coin: gardenToken.name,
                    gardenName: (0,garden/* getGardenName */.gr)(coinMode, type)
                })
            })
        ]
    }));
}
/* harmony default export */ var UseLcroDirectly_AssetExplainer = (AssetExplainer);

// EXTERNAL MODULE: ./src/components/ModalOrDrawer/index.ts
var ModalOrDrawer = __webpack_require__(64881);
// EXTERNAL MODULE: ./src/components/TransactionDrawer/index.tsx + 5 modules
var TransactionDrawer = __webpack_require__(42945);
// EXTERNAL MODULE: ./src/hooks/useGardenApy.ts
var useGardenApy = __webpack_require__(55814);
// EXTERNAL MODULE: ./src/components/Card/index.ts + 1 modules
var Card = __webpack_require__(99726);
// EXTERNAL MODULE: ./src/components/LPTokenIcon.tsx
var LPTokenIcon = __webpack_require__(40266);
// EXTERNAL MODULE: ./src/views/Garden/GardenLogo.tsx
var GardenLogo = __webpack_require__(26835);
// EXTERNAL MODULE: ./src/views/Garden/useGardenModalStore.ts
var useGardenModalStore = __webpack_require__(85985);
// EXTERNAL MODULE: ./src/views/UseLcroDirectly/useSupplyLcroModalStore.ts
var useSupplyLcroModalStore = __webpack_require__(87578);
;// CONCATENATED MODULE: ./src/views/UseLcroDirectly/SupplyTransactionCompleted.tsx












var SupplyTransactionCompletedContent = function(param) {
    var receivedAmount = param.receivedAmount, gardenApy = param.gardenApy, type = param.type;
    var t = (0,i18n/* useTranslations */.T_)();
    var coinMode = (0,useSupplyLcroModalStore/* useSupplyLcroModalStore */.b)(function(s) {
        return s.coinMode;
    });
    var gardenToken = garden/* gardenTokenDict */.Hx[coinMode][type];
    var isAtomTectonicGardenDisabled = coinMode === "atom" && type === "TECTONIC" && !(0,useIsFeatureEnabled/* isFeatureEnabled */.cr)(Features/* features.AtomTectonicGarden */.R.AtomTectonicGarden);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Flex */.kC, {
        mt: "18px",
        flexDir: "column",
        grow: 1,
        gap: 4,
        align: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                textStyle: "h3",
                children: t("Transaction completed!")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Flex */.kC, {
                flexDir: "column",
                align: "center",
                mt: 2,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                        textStyle: "bodySmall",
                        children: t("You have received")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Flex */.kC, {
                        flexDir: "row",
                        alignItems: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LPTokenIcon/* LPTokenIcon */.u, {
                            coinMode: coinMode,
                            gardenType: type,
                            textStyle: "h2",
                            iconWidth: "40px",
                            iconHeight: "40px",
                            children: (0,format/* formatTokenAmount */.LH)(receivedAmount, 3, garden/* gardenTokenDict */.Hx[coinMode][type].decimals)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                hidden: isAtomTectonicGardenDisabled,
                textStyle: "body",
                px: 4,
                mt: "24px",
                textAlign: "center",
                alignSelf: "flex-start",
                // opacity={0.75}
                w: "full",
                children: t("Plant your {coin} in the {platform} to earn VNO rewards", {
                    coin: gardenToken.name,
                    platform: (0,garden/* getGardenName */.gr)(coinMode, type)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* Card */.Z, {
                hidden: isAtomTectonicGardenDisabled,
                colorTheme: (0,garden/* getGardenColorThemeByCoinMode */.Fs)(coinMode, type),
                p: "10px 23px",
                alignSelf: "stretch",
                mt: "8px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Flex */.kC, {
                    gap: "21px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GardenLogo/* GardenLogo */.q, {
                            coinMode: coinMode,
                            gardenType: type,
                            showGardenName: false,
                            showTVL: false
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Box */.xu, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                    textStyle: "h4Bold",
                                    children: (0,garden/* getGardenName */.gr)(coinMode, type)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Text */.xv, {
                                    mt: "8px",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                            as: "span",
                                            color: "text-light",
                                            children: "APY:"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                            as: "span",
                                            textStyle: "bodyBold",
                                            ml: "4px",
                                            children: (0,garden/* formatGardenApy */.VV)(gardenApy)
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var SupplyTransactionCompletedFooter = function(param) {
    var onCloseDrawer = param.onCloseDrawer, type = param.type;
    var t = (0,i18n/* useTranslations */.T_)();
    var close = (0,useSupplyLcroModalStore/* useSupplyLcroModalStore */.b)(function(s) {
        return s.close;
    });
    var coinMode = (0,useSupplyLcroModalStore/* useSupplyLcroModalStore */.b)(function(s) {
        return s.coinMode;
    });
    var openGardenModal = (0,useGardenModalStore/* useGardenModalStore */.q)(function(s) {
        return s.open;
    });
    var gardenToken = garden/* gardenTokenDict */.Hx[coinMode][type];
    var isAtomTectonicGardenDisabled = coinMode === "atom" && type === "TECTONIC" && !(0,useIsFeatureEnabled/* isFeatureEnabled */.cr)(Features/* features.AtomTectonicGarden */.R.AtomTectonicGarden);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Button */.zx, {
                hidden: isAtomTectonicGardenDisabled,
                w: "full",
                variant: "primary",
                mb: "20px",
                onClick: function() {
                    onCloseDrawer();
                    close();
                    openGardenModal({
                        type: type,
                        coinMode: coinMode,
                        activeView: "PLANT"
                    });
                },
                children: t("Plant {coin}", {
                    coin: gardenToken.name
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Button */.zx, {
                variant: isAtomTectonicGardenDisabled ? "primary" : "link",
                textAlign: "center",
                onClick: onCloseDrawer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                    children: t("Done")
                })
            })
        ]
    });
};
var SupplyTransactionCompleted = {
    Content: SupplyTransactionCompletedContent,
    Footer: SupplyTransactionCompletedFooter
};
/* harmony default export */ var UseLcroDirectly_SupplyTransactionCompleted = (SupplyTransactionCompleted);

;// CONCATENATED MODULE: ./src/views/UseLcroDirectly/DoSupplyContent.tsx





function DoSupplyContent(props) {
    var ref = useDoSupplyContent(props), view = ref.view, errorCode = ref.errorCode, errorMessage = ref.errorMessage, gardenApy = ref.gardenApy, receivedAmount = ref.receivedAmount, type = ref.type, nSteps = ref.nSteps, currentStep = ref.currentStep;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            view === "PENDING" && /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionDrawer/* TransactionPending.Content */.$$.Content, {
                nSteps: nSteps,
                currentStep: currentStep
            }),
            view === "ERROR" && /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionDrawer/* TransactionError.Content */.qw.Content, {
                errorCode: errorCode,
                errorMessage: errorMessage
            }),
            view === "COMPLETED" && /*#__PURE__*/ (0,jsx_runtime.jsx)(UseLcroDirectly_SupplyTransactionCompleted.Content, {
                type: type,
                gardenApy: gardenApy,
                receivedAmount: receivedAmount
            })
        ]
    });
}
function DoSupplyContentFooter(param) {
    var onClose = param.onClose, transactionStatus = param.transactionStatus, type = param.type;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            transactionStatus === "PENDING" && /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionDrawer/* TransactionPending.Footer */.$$.Footer, {}),
            transactionStatus === "COMPLETED" && /*#__PURE__*/ (0,jsx_runtime.jsx)(UseLcroDirectly_SupplyTransactionCompleted.Footer, {
                type: type,
                onCloseDrawer: onClose
            })
        ]
    });
}
var useDoSupplyContent = function(param) {
    var coinMode = param.coinMode, transactionStatus = param.transactionStatus, errorCode = param.errorCode, errorMessage = param.errorMessage, type = param.type, receivedAmount = param.receivedAmount, nSteps = param.nSteps, currentStep = param.currentStep;
    var view = "CONFIRM";
    if (transactionStatus === "PENDING") view = "PENDING";
    if (transactionStatus === "COMPLETED") view = "COMPLETED";
    if (errorCode) view = "ERROR";
    var ref = (0,useGardenApy/* default */.Z)(type, false, coinMode), ferroGardenApy = ref.ferroGardenApy, tectonicGardenApy = ref.tectonicGardenApy, vvsGardenApy = ref.vvsGardenApy, vvsCroGardenApy = ref.vvsCroGardenApy;
    var gardenApy = ferroGardenApy !== null && ferroGardenApy !== void 0 ? ferroGardenApy : 0;
    if (type === "TECTONIC") gardenApy = tectonicGardenApy !== null && tectonicGardenApy !== void 0 ? tectonicGardenApy : 0;
    if (type === "VVS") gardenApy = vvsGardenApy !== null && vvsGardenApy !== void 0 ? vvsGardenApy : 0;
    if (type === "VVS_CRO") gardenApy = vvsCroGardenApy !== null && vvsCroGardenApy !== void 0 ? vvsCroGardenApy : 0;
    return {
        view: view,
        errorCode: errorCode,
        errorMessage: errorMessage,
        gardenApy: gardenApy,
        receivedAmount: receivedAmount,
        type: type,
        nSteps: nSteps,
        currentStep: currentStep
    };
};
/* harmony default export */ var UseLcroDirectly_DoSupplyContent = (DoSupplyContent);

;// CONCATENATED MODULE: ./src/views/UseLcroDirectly/DoSupplyDrawer.tsx










function DoSupplyDrawer(_param) {
    var isOpen = _param.isOpen, onClose = _param.onClose, coinMode = _param.coinMode, name = _param.name, onDone = _param.onDone, type = _param.type, supplyContentProps = (0,_object_without_properties/* default */.Z)(_param, [
        "isOpen",
        "onClose",
        "coinMode",
        "name",
        "onDone",
        "type"
    ]);
    var t = (0,i18n/* useTranslations */.T_)();
    var suppliedTokenName = garden/* gardenTokenDict */.Hx[coinMode][type].suppliedTokenName;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalOrDrawer/* ModalOrDrawer */.NH, {
        variant: "wholeScreen",
        placement: "bottom",
        size: {
            base: "full",
            desktop: "md"
        },
        isOpen: isOpen,
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalOrDrawer/* ModalOrDrawerOverlay */.Dx, {
                bg: "bg-gauze"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalOrDrawer/* ModalOrDragDrawerContent */.Zt, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileOrDesktop/* InDesktop */.Fe, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* ModalCloseButton */.ol, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalOrDrawer/* ModalOrDrawerHeader */.BB, {
                        children: t("Supply {coin} on {platform}", {
                            coin: suppliedTokenName,
                            platform: name
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalOrDrawer/* ModalOrDrawerBody */.M1, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UseLcroDirectly_DoSupplyContent, (0,_object_spread/* default */.Z)({
                            coinMode: coinMode,
                            type: type
                        }, supplyContentProps))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalOrDrawer/* ModalOrDrawerFooter */.Un, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DoSupplyContentFooter, {
                            onClose: onDone,
                            type: type,
                            transactionStatus: supplyContentProps.transactionStatus
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var UseLcroDirectly_DoSupplyDrawer = (DoSupplyDrawer);

// EXTERNAL MODULE: ../node_modules/.pnpm/@chakra-ui+hooks@2.0.11_react@18.2.0/node_modules/@chakra-ui/hooks/dist/index.esm.js
var hooks_dist_index_esm = __webpack_require__(19267);
// EXTERNAL MODULE: ./src/config/externalLinks.ts
var externalLinks = __webpack_require__(1797);
;// CONCATENATED MODULE: ./src/views/UseLcroDirectly/SupplyLcroDisclaimer.tsx











function SupplyLcroDisclaimer(param) {
    var type = param.type;
    var t = (0,i18n/* useTranslations */.T_)();
    var coinMode = (0,useSupplyLcroModalStore/* useSupplyLcroModalStore */.b)(function(s) {
        return s.coinMode;
    });
    var ref = (0,hooks_dist_index_esm/* useDisclosure */.qY)(), learnMoreIsOpen = ref.isOpen, toggleLearnMore = ref.onToggle;
    var gardenToken = garden/* gardenTokenDict */.Hx[coinMode][type];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* InColorTheme */.bq, {
                colorTheme: "default",
                isRoot: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SupplyLearnMoreDrawer, {
                    type: type,
                    open: learnMoreIsOpen,
                    close: toggleLearnMore
                })
            }),
            type === "TECTONIC" && /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Box */.xu, {
                children: t("supply-disclaimer-{suppliedTokenName}-{poolName}-{Link}-{platform}", {
                    suppliedTokenName: gardenToken.suppliedTokenName,
                    poolName: gardenToken.poolName,
                    platform: "Tectonic",
                    Link: function() {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Link */.rU, {
                            isExternal: true,
                            color: "pink.500",
                            href: externalLinks/* EXTERNAL_LINK.tectonic */.A.tectonic,
                            children: "Tectonic"
                        });
                    }
                })
            }),
            type === "FERRO" && /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Box */.xu, {
                children: t("supply-disclaimer-{suppliedTokenName}-{poolName}-{Link}-{platform}", {
                    suppliedTokenName: gardenToken.suppliedTokenName,
                    poolName: gardenToken.poolName,
                    platform: "Ferro",
                    Link: function() {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Link */.rU, {
                            isExternal: true,
                            color: "pink.500",
                            href: externalLinks/* EXTERNAL_LINK.ferro */.A.ferro,
                            children: "Ferro"
                        });
                    }
                })
            }),
            type === "VVS" && /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Box */.xu, {
                children: t("supply-disclaimer-{suppliedTokenName}-{poolName}-{Link}-{platform}", {
                    suppliedTokenName: gardenToken.suppliedTokenName,
                    poolName: gardenToken.poolName,
                    platform: "VVS Finance",
                    Link: function() {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Link */.rU, {
                            isExternal: true,
                            color: "pink.500",
                            href: externalLinks/* EXTERNAL_LINK.vvsLanding */.A.vvsLanding,
                            children: "VVS Finance"
                        });
                    }
                })
            }),
            type === "VVS_CRO" && /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Box */.xu, {
                children: t("supply-disclaimer-{suppliedTokenName}-{poolName}-{Link}-{platform}", {
                    suppliedTokenName: gardenToken.suppliedTokenName,
                    poolName: gardenToken.poolName,
                    platform: "VVS Finance",
                    Link: function() {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Link */.rU, {
                            isExternal: true,
                            color: "pink.500",
                            href: externalLinks/* EXTERNAL_LINK.vvsLanding */.A.vvsLanding,
                            children: "VVS Finance"
                        });
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Button */.zx, {
                variant: "link",
                mt: 1.5,
                color: "text-link",
                onClick: toggleLearnMore,
                alignSelf: "flex-start",
                children: t("Learn more")
            })
        ]
    });
}
var SupplyLearnMoreDrawer = function(param) {
    var open = param.open, close = param.close, type = param.type;
    var t = (0,i18n/* useTranslations */.T_)();
    var coinMode = (0,useSupplyLcroModalStore/* useSupplyLcroModalStore */.b)(function(s) {
        return s.coinMode;
    });
    var coinModeInfo = useCoinMode/* COIN_MODE */.rm[coinMode];
    var gardenToken = garden/* gardenTokenDict */.Hx[coinMode][type];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalOrDrawer/* ModalOrDrawer */.NH, {
        variant: "wholeScreen",
        isOpen: open,
        onClose: close,
        scrollBehavior: "inside",
        placement: "bottom",
        size: {
            base: "full",
            desktop: "md"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalOrDrawer/* ModalOrDrawerOverlay */.Dx, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalOrDrawer/* ModalOrDragDrawerContent */.Zt, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalOrDrawer/* ModalOrDrawerHeader */.BB, {
                        children: t("Learn more")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileOrDesktop/* InDesktop */.Fe, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* DrawerCloseButton */.cC, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalOrDrawer/* ModalOrDrawerBodyWithMask */.tN, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                textAlign: "center",
                                mb: "40px",
                                textStyle: "h3",
                                children: getLearnMoreTitle(type, coinMode)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Box */.xu, {
                                textStyle: "body",
                                children: [
                                    type === "FERRO" && /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Box */.xu, {
                                        color: "text-light",
                                        children: t("ferro-learn-more-{suppliedTokenName}-{coin}-{br}-{b}-{FerroLink}", {
                                            coin: coinModeInfo.name,
                                            suppliedTokenName: gardenToken.suppliedTokenName,
                                            br: function() {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {});
                                            },
                                            b: function(chunks) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                    children: chunks
                                                });
                                            },
                                            FerroLink: function() {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Link */.rU, {
                                                    isExternal: true,
                                                    color: "pink.500",
                                                    href: externalLinks/* EXTERNAL_LINK.ferro */.A.ferro,
                                                    children: t("{platform} Website", {
                                                        platform: "Ferro"
                                                    })
                                                });
                                            }
                                        })
                                    }),
                                    type === "TECTONIC" && /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Box */.xu, {
                                        color: "text-light",
                                        children: t("tectonic-learn-more-{suppliedTokenName}-{br}-{TectonicLink}", {
                                            suppliedTokenName: gardenToken.suppliedTokenName,
                                            br: function() {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {});
                                            },
                                            TectonicLink: function() {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Link */.rU, {
                                                    isExternal: true,
                                                    color: "pink.500",
                                                    href: externalLinks/* EXTERNAL_LINK.tectonic */.A.tectonic,
                                                    children: "Tectonic App"
                                                });
                                            }
                                        })
                                    }),
                                    (type === "VVS" || type === "VVS_CRO") && /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Box */.xu, {
                                        color: "text-light",
                                        children: t("vvs-learn-more-{br}-{b}-{VvsLink}", {
                                            br: function() {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {});
                                            },
                                            b: function(chunks) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                    children: chunks
                                                });
                                            },
                                            VvsLink: function() {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Link */.rU, {
                                                    isExternal: true,
                                                    color: "pink.500",
                                                    href: externalLinks/* EXTERNAL_LINK.vvsRemove */.A.vvsRemove,
                                                    children: t("{platform} Website", {
                                                        platform: "VVS Finance"
                                                    })
                                                });
                                            }
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalOrDrawer/* ModalOrDrawerFooter */.Un, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Button */.zx, {
                            mt: "auto",
                            onClick: close,
                            children: t("Close")
                        })
                    })
                ]
            })
        ]
    });
};
var getLearnMoreTitle = function(type, coinMode) {
    var gardenToken = garden/* gardenTokenDict */.Hx[coinMode][type];
    return i18n/* i18next.t */.z2.t("Supply {coin} on {platform}", {
        coin: gardenToken.suppliedTokenName,
        platform: gardenToken.protocolName
    });
};
/* harmony default export */ var UseLcroDirectly_SupplyLcroDisclaimer = (SupplyLcroDisclaimer);

// EXTERNAL MODULE: ../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_async_to_generator.mjs
var src_async_to_generator = __webpack_require__(61706);
// EXTERNAL MODULE: ../node_modules/.pnpm/tslib@2.4.0/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(45813);
// EXTERNAL MODULE: ../node_modules/.pnpm/@chakra-ui+media-query@3.2.7_@chakra-ui+system@2.2.12_react@18.2.0/node_modules/@chakra-ui/media-query/dist/index.esm.js
var media_query_dist_index_esm = __webpack_require__(86434);
// EXTERNAL MODULE: ../node_modules/.pnpm/@ethersproject+bignumber@5.7.0/node_modules/@ethersproject/bignumber/lib.esm/bignumber.js
var bignumber = __webpack_require__(54815);
// EXTERNAL MODULE: ../node_modules/.pnpm/@ethersproject+units@5.7.0/node_modules/@ethersproject/units/lib.esm/index.js + 1 modules
var lib_esm = __webpack_require__(51933);
// EXTERNAL MODULE: ../node_modules/.pnpm/@tanstack+react-query@4.24.10_react-dom@18.2.0_react@18.2.0/node_modules/@tanstack/react-query/build/lib/useQuery.mjs
var useQuery = __webpack_require__(67496);
// EXTERNAL MODULE: ./src/config/paths.ts
var paths = __webpack_require__(71953);
// EXTERNAL MODULE: ./src/hooks/useDebounce.ts
var useDebounce = __webpack_require__(94724);
// EXTERNAL MODULE: ./src/hooks/useLiquidCoinBalance.ts
var useLiquidCoinBalance = __webpack_require__(96164);
// EXTERNAL MODULE: ./src/hooks/useLiquidCoinUsd.ts
var useLiquidCoinUsd = __webpack_require__(20695);
// EXTERNAL MODULE: ./src/hooks/useLpReceiveValue.ts
var useLpReceiveValue = __webpack_require__(76214);
// EXTERNAL MODULE: ./src/hooks/useLpUsdValue.ts
var useLpUsdValue = __webpack_require__(15852);
// EXTERNAL MODULE: ./src/hooks/usePartnerStats.ts
var usePartnerStats = __webpack_require__(82251);
// EXTERNAL MODULE: ./src/hooks/useVnoUsdValue.ts
var useVnoUsdValue = __webpack_require__(96537);
// EXTERNAL MODULE: ./src/providers/VenoSDKProvider.tsx
var VenoSDKProvider = __webpack_require__(29142);
// EXTERNAL MODULE: ./src/queries/partnerApys.ts
var partnerApys = __webpack_require__(75379);
// EXTERNAL MODULE: ./src/queries/queries.ts + 4 modules
var queries = __webpack_require__(54495);
// EXTERNAL MODULE: ./src/queries/queryKey.ts
var queryKey = __webpack_require__(51794);
// EXTERNAL MODULE: ./src/utils/bigNumberToNumber.ts
var bigNumberToNumber = __webpack_require__(19089);
// EXTERNAL MODULE: ./src/utils/urlHistory.ts
var urlHistory = __webpack_require__(59023);
// EXTERNAL MODULE: ../packages/wallet/dist/esm/index.js + 44 modules
var wallet_dist_esm = __webpack_require__(95142);
// EXTERNAL MODULE: ../node_modules/.pnpm/@tanstack+react-query@4.24.10_react-dom@18.2.0_react@18.2.0/node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var QueryClientProvider = __webpack_require__(86599);
// EXTERNAL MODULE: ../node_modules/.pnpm/@tanstack+react-query@4.24.10_react-dom@18.2.0_react@18.2.0/node_modules/@tanstack/react-query/build/lib/useMutation.mjs + 1 modules
var useMutation = __webpack_require__(30235);
// EXTERNAL MODULE: ./src/overrides/next/router.ts
var router = __webpack_require__(95849);
// EXTERNAL MODULE: ./src/utils/tracking.ts + 2 modules
var tracking = __webpack_require__(20115);
;// CONCATENATED MODULE: ./src/hooks/useFerroSupply.ts










var useAccount = wallet_dist_esm/* currentWallet.useAccount */.AX.useAccount;
var useFerroSupply = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _coinMode = ref.coinMode;
    var globalCoinMode = (0,useCoinMode/* useCoinMode */.mc)();
    var coinMode = _coinMode !== null && _coinMode !== void 0 ? _coinMode : globalCoinMode;
    var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    var sdk = (0,VenoSDKProvider/* useVenoSDK */.ho)();
    var userAccount = useAccount();
    var pathname = (0,router/* useRouter */.tv)().pathname;
    var supply = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(amount, expected) {
            var data, _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(coinMode === "atom")) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            sdk.FerroSwapAtom.addLiquidity(amount, expected)
                        ];
                    case 1:
                        _tmp = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            sdk.FerroSwap.addLiquidity(amount, expected)
                        ];
                    case 3:
                        _tmp = _state.sent();
                        _state.label = 4;
                    case 4:
                        data = _tmp;
                        return [
                            4,
                            data.txReceiptPromise
                        ];
                    case 5:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function supply(amount, expected) {
            return _ref.apply(this, arguments);
        };
    }();
    var directDepositFerro = function(param) {
        var amount = param.amount, expected = param.expected;
        return supply(amount, expected);
    };
    return (0,useMutation/* useMutation */.D)(directDepositFerro, {
        onSuccess: function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function(_, vars) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    queryClient.invalidateQueries([
                        queryKey/* QueryKey.LCRO_BALANCE */.S.LCRO_BALANCE
                    ]);
                    queryClient.invalidateQueries([
                        queryKey/* QueryKey.FERRO_LP_BALANCE */.S.FERRO_LP_BALANCE
                    ]);
                    trackFerroDirectDepositEvent(sdk, vars, userAccount !== null && userAccount !== void 0 ? userAccount : "", pathname);
                    return [
                        2
                    ];
                });
            });
            return function(_, vars) {
                return _ref.apply(this, arguments);
            };
        }()
    });
};
function trackFerroDirectDepositEvent(sdk, vars, userAccount, pathname) {
    return _trackFerroDirectDepositEvent.apply(this, arguments);
}
function _trackFerroDirectDepositEvent() {
    _trackFerroDirectDepositEvent = (0,src_async_to_generator/* default */.Z)(function(sdk, vars, userAccount, pathname) {
        var remainingBalance, protocol, isTransaction, amount, entrypoint;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        sdk.LiquidCro.balanceOf(userAccount !== null && userAccount !== void 0 ? userAccount : "")
                    ];
                case 1:
                    remainingBalance = bigNumberToNumber/* default.apply */.Z.apply(void 0, [
                        _state.sent()
                    ]);
                    protocol = "ferro";
                    isTransaction = true;
                    amount = (0,bigNumberToNumber/* default */.Z)(vars.amount);
                    entrypoint = pathname.includes("garden") ? "garden" : "use_lcro";
                    (0,tracking/* trackEvent */.L9)("Deposit LCRO Confirmed", {
                        Amount: amount,
                        isTransaction: isTransaction,
                        Protocol: protocol,
                        "Entry Point": entrypoint,
                        "Remaining Balance": remainingBalance
                    });
                    return [
                        2
                    ];
            }
        });
    });
    return _trackFerroDirectDepositEvent.apply(this, arguments);
}
/* harmony default export */ var hooks_useFerroSupply = (useFerroSupply);

;// CONCATENATED MODULE: ./src/hooks/useTectonicSupply.ts











var useTectonicSupply_useAccount = wallet_dist_esm/* currentWallet.useAccount */.AX.useAccount;
var useTectonicSupply = function() {
    var coinMode = (0,useCoinMode/* useCoinMode */.mc)();
    var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    var pathname = (0,router/* useRouter */.tv)().pathname;
    var sdk = (0,VenoSDKProvider/* useVenoSDK */.ho)();
    var userAccount = useTectonicSupply_useAccount();
    var supply = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(amount) {
            var data, _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(coinMode === "atom")) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            sdk.TLatom.mint(amount)
                        ];
                    case 1:
                        _tmp = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            sdk.TLcro.mint(amount)
                        ];
                    case 3:
                        _tmp = _state.sent();
                        _state.label = 4;
                    case 4:
                        data = _tmp;
                        return [
                            4,
                            data.txReceiptPromise
                        ];
                    case 5:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function supply(amount) {
            return _ref.apply(this, arguments);
        };
    }();
    return (0,useMutation/* useMutation */.D)(function(param) {
        var amount = param.amount;
        return supply(amount);
    }, {
        onSuccess: function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function(_, vars) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    queryClient.invalidateQueries([
                        queryKey/* QueryKey.LCRO_BALANCE */.S.LCRO_BALANCE
                    ]);
                    queryClient.invalidateQueries([
                        queryKey/* QueryKey.TLCRO_BALANCE */.S.TLCRO_BALANCE
                    ]);
                    queryClient.invalidateQueries(useLiquidCoinBalance/* useLiquidCoinBalance.queryKey */.D.queryKey(coinMode));
                    trackTectonicDirectDepositEvent(sdk, vars, userAccount !== null && userAccount !== void 0 ? userAccount : "", pathname);
                    return [
                        2
                    ];
                });
            });
            return function(_, vars) {
                return _ref.apply(this, arguments);
            };
        }()
    });
};
function trackTectonicDirectDepositEvent(sdk, vars, userAccount, pathname) {
    return _trackTectonicDirectDepositEvent.apply(this, arguments);
}
function _trackTectonicDirectDepositEvent() {
    _trackTectonicDirectDepositEvent = (0,src_async_to_generator/* default */.Z)(function(sdk, vars, userAccount, pathname) {
        var remainingBalance, protocol, isTransaction, amount, entrypoint;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        sdk.TLcro.balanceOf(userAccount !== null && userAccount !== void 0 ? userAccount : "")
                    ];
                case 1:
                    remainingBalance = bigNumberToNumber/* default.apply */.Z.apply(void 0, [
                        _state.sent()
                    ]);
                    protocol = "tectonic";
                    isTransaction = true;
                    amount = (0,bigNumberToNumber/* default */.Z)(vars.amount);
                    entrypoint = pathname.includes("garden") ? "garden" : "use_lcro";
                    (0,tracking/* trackEvent */.L9)("Deposit LCRO Confirmed", {
                        Amount: amount,
                        isTransaction: isTransaction,
                        Protocol: protocol,
                        "Entry Point": entrypoint,
                        "Remaining Balance": remainingBalance
                    });
                    return [
                        2
                    ];
            }
        });
    });
    return _trackTectonicDirectDepositEvent.apply(this, arguments);
}
/* harmony default export */ var hooks_useTectonicSupply = (useTectonicSupply);

;// CONCATENATED MODULE: ./src/hooks/useVvsCroSupply.ts





var useVvsSupply = function() {
    var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    var sdk = (0,VenoSDKProvider/* useVenoSDK */.ho)();
    var supply = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(amount, expected) {
            var data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            sdk.VvsZap.addCroLiquidity(amount, expected)
                        ];
                    case 1:
                        data = _state.sent();
                        return [
                            4,
                            data.txReceiptPromise
                        ];
                    case 2:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function supply(amount, expected) {
            return _ref.apply(this, arguments);
        };
    }();
    return (0,useMutation/* useMutation */.D)(function(param) {
        var amount = param.amount, expected = param.expected;
        return supply(amount, expected);
    }, {
        onSuccess: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                queryClient.invalidateQueries([
                    queryKey/* QueryKey.LCRO_BALANCE */.S.LCRO_BALANCE
                ]);
                queryClient.invalidateQueries([
                    queryKey/* QueryKey.VVS_CRO_LP_BALANCE */.S.VVS_CRO_LP_BALANCE
                ]);
                return [
                    2
                ];
            });
        })
    });
};
/* harmony default export */ var useVvsCroSupply = (useVvsSupply);

;// CONCATENATED MODULE: ./src/hooks/useVvsSupply.ts





var useVvsSupply_useVvsSupply = function() {
    var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    var sdk = (0,VenoSDKProvider/* useVenoSDK */.ho)();
    var supply = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(amount, expected) {
            var data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            sdk.VvsZap.addLiquidity(amount, expected)
                        ];
                    case 1:
                        data = _state.sent();
                        return [
                            4,
                            data.txReceiptPromise
                        ];
                    case 2:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function supply(amount, expected) {
            return _ref.apply(this, arguments);
        };
    }();
    return (0,useMutation/* useMutation */.D)(function(param) {
        var amount = param.amount, expected = param.expected;
        return supply(amount, expected);
    }, {
        onSuccess: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                queryClient.invalidateQueries([
                    queryKey/* QueryKey.VNO_BALANCE */.S.VNO_BALANCE
                ]);
                queryClient.invalidateQueries([
                    queryKey/* QueryKey.VVS_LP_BALANCE */.S.VVS_LP_BALANCE
                ]);
                return [
                    2
                ];
            });
        })
    });
};
/* harmony default export */ var hooks_useVvsSupply = (useVvsSupply_useVvsSupply);

;// CONCATENATED MODULE: ./src/views/UseLcroDirectly/useSupplyAction.ts




var useSupplyAction = function(coinMode, type) {
    var ref = hooks_useFerroSupply({
        coinMode: coinMode
    }), doSupplyFerro = ref.mutateAsync;
    var ref1 = hooks_useTectonicSupply(), doSupplyTectonic = ref1.mutateAsync;
    var ref2 = hooks_useVvsSupply(), doSupplyVvs = ref2.mutateAsync;
    var ref3 = useVvsCroSupply(), doSupplyVvsCro = ref3.mutateAsync;
    switch(type){
        case "FERRO":
            return doSupplyFerro;
        case "VVS":
            return doSupplyVvs;
        case "VVS_CRO":
            return doSupplyVvsCro;
        case "TECTONIC":
            return doSupplyTectonic;
    }
};
/* harmony default export */ var UseLcroDirectly_useSupplyAction = (useSupplyAction);

// EXTERNAL MODULE: ../node_modules/.pnpm/@ethersproject+constants@5.7.0/node_modules/@ethersproject/constants/lib.esm/bignumbers.js
var bignumbers = __webpack_require__(5577);
;// CONCATENATED MODULE: ./src/views/UseLcroDirectly/util.ts




function getAllowance(coinMode, type, sdk, account) {
    return _getAllowance.apply(this, arguments);
}
function _getAllowance() {
    _getAllowance = (0,src_async_to_generator/* default */.Z)(function(coinMode, type, sdk, account) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!account) return [
                        2,
                        bignumber/* BigNumber.from */.O$.from(0)
                    ];
                    switch(type){
                        case "FERRO":
                            return [
                                3,
                                1
                            ];
                        case "VVS":
                            return [
                                3,
                                5
                            ];
                        case "VVS_CRO":
                            return [
                                3,
                                7
                            ];
                        case "TECTONIC":
                            return [
                                3,
                                9
                            ];
                    }
                    return [
                        3,
                        10
                    ];
                case 1:
                    if (!(coinMode === "atom")) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        sdk.LiquidAtom.allowance(account, sdk.FerroSwapAtom.contractAddress)
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
                case 3:
                    return [
                        4,
                        sdk.LiquidCro.allowance(account, sdk.FerroSwap.contractAddress)
                    ];
                case 4:
                    return [
                        2,
                        _state.sent()
                    ];
                case 5:
                    return [
                        4,
                        sdk.VenoToken.allowance(account, sdk.VvsZap.contractAddress)
                    ];
                case 6:
                    return [
                        2,
                        _state.sent()
                    ];
                case 7:
                    return [
                        4,
                        sdk.LiquidCro.allowance(account, sdk.VvsZap.contractAddress)
                    ];
                case 8:
                    return [
                        2,
                        _state.sent()
                    ];
                case 9:
                    return [
                        2,
                        coinMode === "atom" ? sdk.LiquidAtom.allowance(account, sdk.TLatom.contractAddress) : sdk.LiquidCro.allowance(account, sdk.TLcro.contractAddress)
                    ];
                case 10:
                    return [
                        2
                    ];
            }
        });
    });
    return _getAllowance.apply(this, arguments);
}
function approve(coinMode, type, sdk) {
    return _approve.apply(this, arguments);
}
function _approve() {
    _approve = (0,src_async_to_generator/* default */.Z)(function(coinMode, type, sdk) {
        var _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    switch(type){
                        case "FERRO":
                            return [
                                3,
                                1
                            ];
                        case "VVS":
                            return [
                                3,
                                5
                            ];
                        case "VVS_CRO":
                            return [
                                3,
                                7
                            ];
                        case "TECTONIC":
                            return [
                                3,
                                9
                            ];
                    }
                    return [
                        3,
                        14
                    ];
                case 1:
                    if (!(coinMode === "atom")) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        sdk.LiquidAtom.approve(sdk.FerroSwapAtom.contractAddress, bignumbers/* MaxUint256 */.Bz)
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
                case 3:
                    return [
                        4,
                        sdk.LiquidCro.approve(sdk.FerroSwap.contractAddress, bignumbers/* MaxUint256 */.Bz)
                    ];
                case 4:
                    return [
                        2,
                        _state.sent()
                    ];
                case 5:
                    return [
                        4,
                        sdk.VenoToken.approve(sdk.VvsZap.contractAddress, bignumbers/* MaxUint256 */.Bz)
                    ];
                case 6:
                    return [
                        2,
                        _state.sent()
                    ];
                case 7:
                    return [
                        4,
                        sdk.LiquidCro.approve(sdk.VvsZap.contractAddress, bignumbers/* MaxUint256 */.Bz)
                    ];
                case 8:
                    return [
                        2,
                        _state.sent()
                    ];
                case 9:
                    if (!(coinMode === "atom")) return [
                        3,
                        11
                    ];
                    return [
                        4,
                        sdk.LiquidAtom.approve(sdk.TLatom.contractAddress, bignumbers/* MaxUint256 */.Bz)
                    ];
                case 10:
                    _tmp = _state.sent();
                    return [
                        3,
                        13
                    ];
                case 11:
                    return [
                        4,
                        sdk.LiquidCro.approve(sdk.TLcro.contractAddress, bignumbers/* MaxUint256 */.Bz)
                    ];
                case 12:
                    _tmp = _state.sent();
                    _state.label = 13;
                case 13:
                    return [
                        2,
                        _tmp
                    ];
                case 14:
                    return [
                        2
                    ];
            }
        });
    });
    return _approve.apply(this, arguments);
}
function getReceived(coinMode, type, sdk, // don't import type just for this line
// eslint-disable-next-line @typescript-eslint/no-explicit-any
receipt) {
    switch(type){
        case "FERRO":
            if (coinMode === "atom") {
                var ref;
                return (ref = sdk.FerroSwapAtom.getReceivedLp(receipt)) !== null && ref !== void 0 ? ref : bignumber/* BigNumber.from */.O$.from(0);
            }
            var ref1;
            return (ref1 = sdk.FerroSwap.getReceivedLp(receipt)) !== null && ref1 !== void 0 ? ref1 : bignumber/* BigNumber.from */.O$.from(0);
        case "VVS":
        case "VVS_CRO":
            var ref2;
            return (ref2 = sdk.VvsZap.getReceivedVvsLp(receipt)) !== null && ref2 !== void 0 ? ref2 : bignumber/* BigNumber.from */.O$.from(0);
        case "TECTONIC":
            var ref3;
            return (ref3 = sdk.TLcro.getReceivedTLcro(receipt)) !== null && ref3 !== void 0 ? ref3 : bignumber/* BigNumber.from */.O$.from(0);
    }
}
function getDepositDirectUsdValue(type, sdk, amount, oneVnoUsdValue) {
    return _getDepositDirectUsdValue.apply(this, arguments);
}
function _getDepositDirectUsdValue() {
    _getDepositDirectUsdValue = _async_to_generator(function(type, sdk, amount, oneVnoUsdValue) {
        return _ts_generator(this, function(_state) {
            switch(type){
                case "FERRO":
                case "TECTONIC":
                case "VVS_CRO":
                    return [
                        2,
                        sdk.LiquidCro.getUsdWorth(amount)
                    ];
                case "VVS":
                    return [
                        2,
                        amount.mul(Math.round(100000000 * oneVnoUsdValue)).div(100000000)
                    ];
            }
            return [
                2
            ];
        });
    });
    return _getDepositDirectUsdValue.apply(this, arguments);
}

;// CONCATENATED MODULE: ./src/views/UseLcroDirectly/useSupplyLcroModal.ts
































var useIsConnected = wallet_dist_esm/* currentWallet.useIsConnected */.AX.useIsConnected, useSupplyLcroModal_useAccount = wallet_dist_esm/* currentWallet.useAccount */.AX.useAccount;
var useSupplyLcroModal = function() {
    var t = (0,i18n/* useTranslations */.T_)();
    var ref = (0,useSupplyLcroModalStore/* useSupplyLcroModalStore */.b)(), isOpen = ref.isOpen, close = ref.close, type = ref.type, coinMode = ref.coinMode;
    var coinModeInfo = useCoinMode/* COIN_MODE */.rm[coinMode];
    var account = useSupplyLcroModal_useAccount();
    var isConnected = useIsConnected();
    var sdk = (0,VenoSDKProvider/* useVenoSDK */.ho)();
    var tectonicApyRet = (0,usePartnerStats/* useTectonicApy */.Gh)(type === "TECTONIC");
    var ferroApyQuery = (0,partnerApys/* getFerroApy */.qe)(coinMode, true);
    var vvsApyQuery = (0,partnerApys/* getVvsApy */.Q7)(true);
    var vvsCroApyQuery = (0,partnerApys/* getVvsCroApy */.Pi)(true);
    var ref1 = (0,useVnoUsdValue/* useVnoUsdValue */.R)(1), oneVnoUsdValue = ref1.data;
    var ref2 = (0,react.useState)(""), inputError = ref2[0], setInputError = ref2[1];
    var ref3 = (0,react.useState)(""), supplyAmount = ref3[0], setSupplyAmount = ref3[1];
    var ref4 = (0,react.useState)(false), drawerOpen = ref4[0], setDrawerOpen = ref4[1];
    var ref5 = (0,react.useState)(2), nSteps = ref5[0], setNSteps = ref5[1];
    var ref6 = (0,react.useState)(0), currentStep = ref6[0], setCurrentStep = ref6[1];
    var ref7 = (0,react.useState)(bignumber/* BigNumber.from */.O$.from(0)), receivedAmount = ref7[0], setReceivedAmount = ref7[1];
    var ref8 = (0,useQuery/* useQuery */.a)(ferroApyQuery.queryKey, ferroApyQuery.queryFn, {
        enabled: type === "FERRO"
    }), ferroApy = ref8.data, ferroApyError = ref8.error;
    var ref9 = (0,useQuery/* useQuery */.a)(vvsApyQuery.queryKey, vvsApyQuery.queryFn, {
        enabled: type === "VVS"
    }), vvsApy = ref9.data;
    var ref10 = (0,useQuery/* useQuery */.a)(vvsCroApyQuery.queryKey, vvsCroApyQuery.queryFn, {
        enabled: type === "VVS_CRO"
    }), vvsCroApy = ref10.data;
    var debouncedSupply = (0,useDebounce/* default */.Z)(supplyAmount, 500);
    var assetName = garden/* gardenTokenDict */.Hx[coinMode][type].name;
    var isDesktop = (0,media_query_dist_index_esm/* useBreakpointValue */.Sx)({
        base: false,
        desktop: true
    });
    var ref11 = (0,react.useState)(false), assetInfoDrawerOpen = ref11[0], setAssetInfoDrawerOpen = ref11[1];
    var ref12 = (0,react.useState)(""), errorCode = ref12[0], setErrorCode = ref12[1];
    var ref13 = (0,react.useState)(""), errorMessage = ref13[0], setErrorMessage = ref13[1];
    var ref14 = (0,react.useState)("CONFIRM"), transactionStatus = ref14[0], setTransactionStatus = ref14[1];
    var doSupply = UseLcroDirectly_useSupplyAction(coinMode, type);
    var closeAndReset = (0,react.useCallback)(function() {
        close();
        setDrawerOpen(false);
        setSupplyAmount("");
        setInputError("");
        setAssetInfoDrawerOpen(false);
        setTransactionStatus("CONFIRM");
        setErrorCode("");
        setErrorMessage("");
        setNSteps(2);
        setReceivedAmount(bignumber/* BigNumber.from */.O$.from(0));
        if ( true && window.location.search.includes("deposit")) {
            (0,urlHistory/* replaceRouterWithoutRerender */.l)(paths/* pathDict */.o$[coinMode].useLiquid);
        }
    }, [
        close,
        coinMode
    ]);
    var closeDrawer = function() {
        setDrawerOpen(false);
        if (transactionStatus === "COMPLETED") closeAndReset();
        else {
            setInputError("");
            setErrorCode("");
            setErrorMessage("");
        }
    };
    var ref15 = (0,useGardenApy/* default */.Z)(type), ferroGardenApy = ref15.ferroGardenApy, tectonicGardenApy = ref15.tectonicGardenApy, vvsGardenApy = ref15.vvsGardenApy, vvsCroGardenApy = ref15.vvsCroGardenApy;
    var gardenApy = tectonicGardenApy;
    var apy = tectonicApyRet.data;
    var apyError = tectonicApyRet.error;
    var cover = "/images/tectonic-cover.png";
    var brandColor = "#1F1F3F";
    var name = "Tectonic";
    var gradient1 = "linear-gradient(182.36deg, #1F1F3F 1.98%, rgba(31, 31, 63, 0) 119.28%)";
    var gradient2 = "linear-gradient(182.88deg, #1F1F3F 2.4%, rgba(31, 31, 63, 0) 97.61%)";
    var shadows = [
        "#68688d",
        "#000001"
    ];
    switch(type){
        case "FERRO":
            brandColor = "#1A1A1A";
            apy = ferroApy;
            apyError = ferroApyError;
            name = "Ferro";
            gradient1 = "";
            gradient2 = "";
            cover = "/images/ferro-cover.png";
            shadows = [
                "#666666",
                "#000000"
            ];
            gardenApy = ferroGardenApy;
            break;
        case "VVS":
            brandColor = "#F4F5F1";
            apy = vvsApy;
            name = "VVS";
            gradient1 = "";
            gradient2 = "linear-gradient(182.88deg, #F4F5F1 2.4%, rgba(244, 245, 241, 0) 80%);";
            cover = "/images/vvs-cover.png";
            shadows = [
                "#ffffff",
                "#c5c6c3"
            ];
            gardenApy = vvsGardenApy;
            break;
        case "VVS_CRO":
            brandColor = "#F4F5F1";
            apy = vvsCroApy;
            name = "VVS CRO";
            gradient1 = "";
            gradient2 = "linear-gradient(182.88deg, #EBF0F3 2.4%, rgba(235, 240, 243, 0) 97.61%)";
            cover = "/images/vvs-cover.png";
            shadows = [
                "#ffffff",
                "#c5c6c3"
            ];
            gardenApy = vvsCroGardenApy;
            break;
    }
    var ref16 = (0,useLpReceiveValue/* default */.Z)(coinMode, type, supplyAmount), exchangeRate = ref16.exchangeRate, exchangeRateFetching = ref16.isFetching, receiveAmount = ref16.receiveAmount;
    var receiveAmountUsd = (0,useLpUsdValue/* default */.Z)(type, receiveAmount ? String(receiveAmount) : "");
    var handleSupply = (0,react.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        var allowance, amount, approveRet, p, received, e, errorCode;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    setDrawerOpen(true);
                    setTransactionStatus("PENDING");
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        8,
                        ,
                        9
                    ]);
                    return [
                        4,
                        getAllowance(coinMode, type, sdk, account)
                    ];
                case 2:
                    allowance = _state.sent();
                    amount = (0,format/* parseValue */.H2)(supplyAmount, coinModeInfo.liquidDecimals);
                    if (!allowance.lt(amount)) return [
                        3,
                        5
                    ];
                    // not yet approved.
                    // 2 steps:
                    // 1. approve, 2. deposit
                    setNSteps(2);
                    setCurrentStep(1);
                    return [
                        4,
                        approve(coinMode, type, sdk)
                    ];
                case 3:
                    approveRet = _state.sent();
                    return [
                        4,
                        approveRet.txReceiptPromise
                    ];
                case 4:
                    _state.sent();
                    // approval done, now got to step 2, deposit
                    setCurrentStep(2);
                    return [
                        3,
                        6
                    ];
                case 5:
                    // it was already approved, only one step, which is "deposit"
                    setNSteps(1);
                    setCurrentStep(1);
                    _state.label = 6;
                case 6:
                    return [
                        4,
                        doSupply({
                            amount: amount,
                            expected: receiveAmount !== null && receiveAmount !== void 0 ? receiveAmount : 0
                        })
                    ];
                case 7:
                    p = _state.sent();
                    setTransactionStatus("COMPLETED");
                    received = getReceived(coinMode, type, sdk, p);
                    setReceivedAmount(received);
                    return [
                        3,
                        9
                    ];
                case 8:
                    e = _state.sent();
                    console.error(e);
                    setTransactionStatus("ERROR");
                    errorCode = e.code;
                    if (e.message) {
                        setErrorMessage(e.message);
                    }
                    setErrorCode(errorCode);
                    return [
                        3,
                        9
                    ];
                case 9:
                    return [
                        2
                    ];
            }
        });
    }), [
        account,
        coinMode,
        coinModeInfo.liquidDecimals,
        doSupply,
        receiveAmount,
        sdk,
        supplyAmount,
        type, 
    ]);
    var ref17 = (0,useLiquidCoinBalance/* useLiquidCoinBalance */.D)({
        coinMode: coinMode,
        enabled: !!account && type !== "VVS"
    }), liquidCoinBalance = ref17.data;
    var ref18 = (0,useLiquidCoinUsd/* useLiquidCoinUsd */.m)({
        coinMode: coinMode,
        amount: liquidCoinBalance
    }), liquidCoinUsd = ref18.data;
    var debouncedSupplyBn = debouncedSupply ? (0,format/* parseValue */.H2)(debouncedSupply, coinModeInfo.liquidDecimals) : undefined;
    var ref19 = (0,useLiquidCoinUsd/* useLiquidCoinUsd */.m)({
        coinMode: coinMode,
        amount: debouncedSupplyBn
    }), lpUsdWorthBn = ref19.data;
    var lpUsdWorth = (0,react.useMemo)(function() {
        if (!debouncedSupplyBn || inputError && inputError !== t("Insufficient Balance")) {
            return undefined;
        }
        if (type === "VVS") {
            return (0,bigNumberToNumber/* default */.Z)(debouncedSupplyBn.mul(Math.round(100000000 * (oneVnoUsdValue !== null && oneVnoUsdValue !== void 0 ? oneVnoUsdValue : 0))).div(100000000));
        }
        return lpUsdWorthBn ? (0,bigNumberToNumber/* default */.Z)(lpUsdWorthBn) : undefined;
    }, [
        debouncedSupplyBn,
        inputError,
        lpUsdWorthBn,
        oneVnoUsdValue,
        t,
        type
    ]);
    var inputWarning = (0,react.useMemo)(function() {
        if (typeof lpUsdWorth === "undefined" || typeof receiveAmountUsd === "undefined") {
            return undefined;
        }
        if (receiveAmountUsd <= lpUsdWorth * 0.9) {
            return t("supply-reduce-warning-{coin}", {
                coin: garden/* gardenTokenDict */.Hx[coinMode][type].name
            });
        }
    }, [
        coinMode,
        lpUsdWorth,
        receiveAmountUsd,
        t,
        type
    ]);
    var vnoBalanceQuery = (0,queries/* getQuery */.p)(queryKey/* QueryKey.VNO_BALANCE */.S.VNO_BALANCE)(sdk, account !== null && account !== void 0 ? account : "");
    var ref20 = (0,useQuery/* useQuery */.a)(vnoBalanceQuery.queryKey, vnoBalanceQuery.queryFn, {
        enabled: !!account && type === "VVS"
    }), vnoBalance = ref20.data;
    var ref21 = (0,useVnoUsdValue/* useVnoUsdValue */.R)(vnoBalance), vnoBalanceUsd = ref21.data;
    var balance = type === "VVS" ? vnoBalance : liquidCoinBalance;
    var balanceUsd = type === "VVS" ? vnoBalanceUsd : liquidCoinUsd;
    var ref22;
    var maxAmount = balance ? Math.floor(100000000 * parseFloat((ref22 = (0,lib_esm.formatUnits)(balance, coinModeInfo.liquidDecimals)) !== null && ref22 !== void 0 ? ref22 : "0")) / 100000000 : undefined;
    var handleInputChange = (0,react.useCallback)(function(value) {
        if (value && !/^[0-9]+\.?[0-9]*$/.test(value)) {
            setInputError(t("invalid format"));
        } else if (maxAmount !== undefined && parseFloat(value) > maxAmount) {
            setInputError(t("Insufficient Balance"));
        } else {
            setInputError("");
        }
        setSupplyAmount(value);
    }, [
        maxAmount,
        t
    ]);
    return {
        brandColor: brandColor,
        apy: (0,react.useMemo)(function() {
            if (coinMode === "atom" && type === "TECTONIC" && !(0,useIsFeatureEnabled/* isFeatureEnabled */.cr)(Features/* features.AtomTectonicGarden */.R.AtomTectonicGarden)) {
                return typeof apy === "number" ? apy : undefined;
            }
            return typeof apy === "number" && typeof gardenApy === "number" ? apy + gardenApy * 100 : undefined;
        }, [
            apy,
            coinMode,
            gardenApy,
            type
        ]),
        apyError: apyError,
        name: name,
        balance: balance,
        balanceUsd: balanceUsd,
        gradient1: gradient1,
        gradient2: gradient2,
        cover: cover,
        maxAmount: maxAmount,
        shadows: shadows,
        handleInputChange: handleInputChange,
        supplyAmount: supplyAmount,
        inputError: inputError,
        inputWarning: inputWarning,
        assetInfoDrawerOpen: assetInfoDrawerOpen,
        isOpen: isOpen && isConnected,
        closeAndReset: closeAndReset,
        type: type,
        setAssetInfoDrawerOpen: setAssetInfoDrawerOpen,
        isDesktop: isDesktop,
        transactionStatus: transactionStatus,
        errorCode: errorCode,
        errorMessage: errorMessage,
        nSteps: nSteps,
        currentStep: currentStep,
        handleSupply: handleSupply,
        closeDrawer: closeDrawer,
        drawerOpen: drawerOpen,
        assetName: assetName,
        exchangeRate: exchangeRate,
        receiveAmount: receiveAmount,
        receiveAmountUsd: receiveAmountUsd,
        receivedAmount: receivedAmount,
        exchangeRateFetching: exchangeRateFetching,
        gardenApy: gardenApy,
        lpUsdWorth: lpUsdWorth
    };
};
/* harmony default export */ var UseLcroDirectly_useSupplyLcroModal = (useSupplyLcroModal);

;// CONCATENATED MODULE: ./src/views/UseLcroDirectly/SupplyLcroModal.tsx
























var isAtomTectonicGardenEnabled = (0,useIsFeatureEnabled/* isFeatureEnabled */.cr)(Features/* features.AtomTectonicGarden */.R.AtomTectonicGarden);
function SupplyLcroModal() {
    var t = (0,i18n/* useTranslations */.T_)();
    var ref = UseLcroDirectly_useSupplyLcroModal(), isOpen = ref.isOpen, closeAndReset = ref.closeAndReset, apy = ref.apy, apyError = ref.apyError, gradient1 = ref.gradient1, gradient2 = ref.gradient2, name = ref.name, balance = ref.balance, cover = ref.cover, balanceUsd = ref.balanceUsd, maxAmount = ref.maxAmount, handleInputChange = ref.handleInputChange, inputError = ref.inputError, inputWarning = ref.inputWarning, supplyAmount = ref.supplyAmount, transactionStatus = ref.transactionStatus, errorCode = ref.errorCode, errorMessage = ref.errorMessage, handleSupply = ref.handleSupply, closeDrawer = ref.closeDrawer, drawerOpen = ref.drawerOpen, assetName = ref.assetName, exchangeRateFetching = ref.exchangeRateFetching, type = ref.type, exchangeRate = ref.exchangeRate, receiveAmount = ref.receiveAmount, receiveAmountUsd = ref.receiveAmountUsd, currentStep = ref.currentStep, receivedAmount = ref.receivedAmount, nSteps = ref.nSteps, gardenApy = ref.gardenApy, lpUsdWorth = ref.lpUsdWorth;
    var coinMode = (0,useSupplyLcroModalStore/* useSupplyLcroModalStore */.b)(function(s) {
        return s.coinMode;
    });
    var onBackward = (0,useSupplyLcroModalStore/* useSupplyLcroModalStore */.b)(function(s) {
        return s.onBackward;
    });
    var coinModeInfo = useCoinMode/* COIN_MODE */.rm[coinMode];
    var suppliedTokenName = garden/* gardenTokenDict */.Hx[coinMode][type].suppliedTokenName;
    var maxDecimalsAllowed = coinModeInfo.liquidDecimals;
    var ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UseLcroDirectly_DoSupplyDrawer, {
                coinMode: coinMode,
                name: name,
                isOpen: drawerOpen,
                onClose: closeDrawer,
                onDone: closeAndReset,
                transactionStatus: transactionStatus,
                errorCode: errorCode,
                errorMessage: errorMessage,
                receivedAmount: receivedAmount,
                type: type,
                nSteps: nSteps,
                currentStep: currentStep
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Modal */.u_, {
                variant: "wholeScreen",
                size: {
                    base: "full",
                    desktop: "3xl"
                },
                isOpen: isOpen,
                onClose: closeAndReset,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* ModalOverlay */.ZA, {
                        bg: "bg-gauze"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* InColorTheme */.bq, {
                        colorTheme: type,
                        isRoot: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* ModalContent */.hz, {
                            bgColor: "var(".concat(esm/* ColorThemeVars.mainColor */.lx.mainColor, ")"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* ModalHeader */.xB, {
                                    textAlign: "center",
                                    position: "relative",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileOrDesktop/* RenderInDesktop */.Po, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Button */.zx, {
                                                hidden: !onBackward,
                                                variant: "link",
                                                color: "text-link",
                                                position: "absolute",
                                                left: "10px",
                                                top: "16px",
                                                leftIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                                                    as: dist_esm/* ArrowBack */.xh,
                                                    boxSize: "15px"
                                                }),
                                                onClick: function() {
                                                    if (onBackward) {
                                                        onBackward();
                                                    }
                                                    closeAndReset();
                                                },
                                                children: t("Back to {page}", {
                                                    page: (0,garden/* getGardenName */.gr)(coinMode, type)
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                            css: {
                                                "--test-a-b": "inset -4px -4px 5px #ffffff,inset 3px 4px 5px #c5c6c3"
                                            },
                                            children: t("Supply {coin} on {platform}", {
                                                coin: suppliedTokenName,
                                                platform: name
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileOrDesktop/* RenderInMobile */.ub, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* ModalCloseButton */.ol, {
                                        variant: "smallCard",
                                        size: "xs"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileOrDesktop/* RenderInDesktop */.Po, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* InGauze */.Am, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* InColorTheme */.bq, {
                                            colorTheme: type,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* ModalCloseButton */.ol, {
                                                variant: "smallCard",
                                                size: "xs",
                                                position: "absolute",
                                                left: "calc(100% + 10px)",
                                                top: "0"
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* ModalBody */.fe, {
                                    pb: {
                                        base: 6,
                                        desktop: 11
                                    },
                                    px: 0,
                                    position: "relative",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Box */.xu, {
                                            w: "full",
                                            position: "absolute",
                                            top: "0",
                                            left: "0",
                                            zIndex: 0,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Box */.xu, {
                                                    background: gradient1,
                                                    h: "61px",
                                                    w: "full",
                                                    position: "absolute",
                                                    zIndex: 1
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Box */.xu, {
                                                    background: gradient2,
                                                    h: "80px",
                                                    transform: "rotate(-180deg)",
                                                    w: "full",
                                                    bottom: 0,
                                                    position: "absolute",
                                                    zIndex: 1
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(image_dist_index_esm/* Image */.Ee, {
                                                    zIndex: 0,
                                                    w: "full",
                                                    alt: "Partner",
                                                    src: cover,
                                                    height: {
                                                        base: "auto",
                                                        desktop: "211px"
                                                    },
                                                    opacity: type === "VVS" || type === "VVS_CRO" ? "0.6" : "1",
                                                    objectFit: type === "VVS" || type === "VVS_CRO" ? "contain" : "cover",
                                                    objectPosition: "center center"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                                            maxW: {
                                                base: "unset",
                                                desktop: "500px"
                                            },
                                            mx: "auto",
                                            mt: {
                                                base: "150px",
                                                desktop: "80px"
                                            },
                                            title: t("Wallet {coin} Balance", {
                                                coin: suppliedTokenName
                                            }),
                                            amount: balance,
                                            unitDecimals: coinModeInfo.liquidDecimals,
                                            icon: type === "VVS" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenIcon/* TokenIcon */.T, {
                                                token: "vvs"
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(coinModeInfo.LiquidIcon, {}),
                                            usdAmount: balanceUsd,
                                            usdDisplayDecimals: 2,
                                            zIndex: 1,
                                            position: "relative",
                                            invertedColors: type !== "VVS" && type !== "VVS_CRO",
                                            showUsdAmount: true
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Flex */.kC, {
                                            flexDir: "column",
                                            mt: "20px",
                                            maxW: {
                                                base: "unset",
                                                desktop: "500px"
                                            },
                                            mx: {
                                                base: 4,
                                                desktop: "auto"
                                            },
                                            position: "relative",
                                            zIndex: "1",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UseLcroDirectly_SupplyLcroDisclaimer, {
                                                    type: type
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Info/* default */.Z, {
                                                    mt: 6,
                                                    title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            "APY",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoTooltip/* InfoTooltip */.b, {
                                                                title: "APY",
                                                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                                                    px: {
                                                                        base: 0,
                                                                        desktop: 8
                                                                    },
                                                                    py: {
                                                                        base: 0,
                                                                        desktop: 4
                                                                    },
                                                                    children: getLpApyExplainer(coinMode, type)
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    value: apyError ? "--" : typeof apy === "number" ? "".concat((0,format/* formatNumber */.uf)(apy, 2), "%") : undefined
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(InputCard/* InputCard */.K, {
                                                    mt: 3,
                                                    max: maxAmount,
                                                    label: t("Input {coin} amount", {
                                                        coin: suppliedTokenName
                                                    }),
                                                    maxDecimals: maxDecimalsAllowed,
                                                    value: supplyAmount,
                                                    onChange: handleInputChange,
                                                    errorMessage: inputError,
                                                    usdValue: lpUsdWorth
                                                }),
                                                inputWarning && /*#__PURE__*/ (0,jsx_runtime.jsx)(NoteBox/* NoteBox */.u, {
                                                    mt: "14px",
                                                    mb: "10px",
                                                    desc: inputWarning
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Button */.zx, {
                                                    onClick: handleSupply,
                                                    variant: "pink",
                                                    mt: "14px",
                                                    disabled: !!inputError || !receiveAmount,
                                                    w: {
                                                        desktop: constants/* MAXW_DESKTOP_CTA */.D3
                                                    },
                                                    mx: {
                                                        desktop: "auto"
                                                    },
                                                    children: t("Supply now")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Flex */.kC, {
                                                    flexDir: "column",
                                                    mt: 6,
                                                    gap: 3,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Info/* default */.Z, {
                                                            flexGrow: 1,
                                                            title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                children: [
                                                                    t("{coin} to receive", {
                                                                        coin: assetName
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoTooltip/* InfoTooltip */.b, {
                                                                        title: garden/* gardenTokenDict */.Hx[coinMode][type].name,
                                                                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(UseLcroDirectly_AssetExplainer, {
                                                                            coinMode: coinMode,
                                                                            explainText: "TOKEN",
                                                                            type: type
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            value: exchangeRateFetching ? undefined : (ref1 = receiveAmount === null || receiveAmount === void 0 ? void 0 : receiveAmount.toFixed(4)) !== null && ref1 !== void 0 ? ref1 : "--",
                                                            convertedValue: receiveAmountUsd ? "$".concat((0,format/* formatNumber */.uf)(receiveAmountUsd, 2)) : "--"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Info/* default */.Z, {
                                                            title: t("Exchange rate"),
                                                            value: exchangeRateFetching ? undefined : exchangeRate ? "1 ".concat(coinModeInfo.liquidName, " : ").concat(exchangeRate.toFixed(4)) : "--"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Info/* default */.Z, {
                                                            hidden: coinMode === "atom" && type === "TECTONIC" && !isAtomTectonicGardenEnabled,
                                                            title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                children: [
                                                                    (0,garden/* getGardenName */.gr)(coinMode, type),
                                                                    " APR",
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoTooltip/* InfoTooltip */.b, {
                                                                        title: (0,garden/* getGardenName */.gr)(coinMode, type),
                                                                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(UseLcroDirectly_AssetExplainer, {
                                                                            coinMode: coinMode,
                                                                            explainText: "GARDEN",
                                                                            type: type
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            value: gardenApy !== undefined ? "".concat((0,garden/* formatGardenApy */.VV)(gardenApy)) : undefined
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
var getLpApyExplainer = function(coinMode, gardenType) {
    var gardenName = (0,garden/* getGardenName */.gr)(coinMode, gardenType);
    var gardenToken = garden/* gardenTokenDict */.Hx[coinMode][gardenType];
    switch(gardenType){
        case "FERRO":
            return i18n/* i18next.t */.z2.t("ferro-explainer-{gardenName}", {
                gardenName: gardenName
            });
        case "VVS":
        case "VVS_CRO":
            return i18n/* i18next.t */.z2.t("vvs-explainer-{gardenName}", {
                gardenName: gardenName
            });
        case "TECTONIC":
            if (coinMode === "atom" && !(0,useIsFeatureEnabled/* isFeatureEnabled */.cr)(Features/* features.AtomTectonicGarden */.R.AtomTectonicGarden)) {
                return i18n/* i18next.t */.z2.t("tectonic-explainer-without-garden-{suppliedTokenName}", {
                    suppliedTokenName: gardenToken.suppliedTokenName
                });
            }
            return i18n/* i18next.t */.z2.t("tectonic-explainer-{suppliedTokenName}-{coin}-{gardenName}", {
                suppliedTokenName: gardenToken.suppliedTokenName,
                coin: gardenToken.name,
                gardenName: gardenName
            });
    }
};
var SupplyModal = function() {
    var coinMode = (0,useSupplyLcroModalStore/* useSupplyLcroModalStore */.b)(function(s) {
        return s.coinMode;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(useCoinMode/* CoinModeProvider */.B2, {
        value: coinMode,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SupplyLcroModal, {})
    });
};
/* harmony default export */ var UseLcroDirectly_SupplyLcroModal = (SupplyModal);


/***/ })

}]);